import '.i5{width:1px;}.ssr-plugin'
import '.cr{height:1rem;}.ssr-plugin'
import '.i6{background-color:var(--shades-blue-300);}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import {
  faLocationDot,
  faHourglass,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'

export type InitiativeStatusRowProps = {
  location: string
  status?: string
}

export const InitiativeStatusRow = ({
  location,
  status,
}: InitiativeStatusRowProps) => {
  return (
    <Row
      style={{
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      <Section text={location} icon={faLocationDot} />

      {/* Separator */}
      {status && (
        <div className="i5 cr i6"
        />
      )}

      {status && <Section text={status} icon={faHourglass} />}
    </Row>
  )
}

const Section = ({ text, icon }: { text: string; icon: IconDefinition }) => {
  return (
    <Row
      style={{
        alignItems: 'center',
        gap: '0.25rem',
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        style={{
          color: 'var(--primary-blue)',
          height: '0.75rem',
          width: '0.75rem',
        }}
      />
      <Text.Small
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
        }}
      >
        {text}
      </Text.Small>
      {/* TODO: Laurie will handle in follow up ticket ENG-972 */}
    </Row>
  )
}
